import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-message-notification-modal',
  templateUrl: './message-notification-modal.component.html',
  styleUrls: ['./message-notification-modal.component.css']
})
export class MessageNotificationModalComponent implements OnInit {
  @Input() messageDetail; 
  @Output() close = new EventEmitter<any>();

  constructor(private router : Router) { }

  ngOnInit() {
  }

  navigation(value){
    this.router.navigate(['/support/driver-alerts/'], { state: { id: `${value.driverAlert.sender._id}` } });

  }
}
